import React, { useEffect, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '~/common/components/PageTitle';
import { useAxeAccountAnalytics } from '~/common/contexts/analytics';
import globalStyles from '../app.css';
import UserManagement from '../containers/UserManagement';

interface UserManagementPageProps {
  editingAccess?: boolean;
}

const UserManagementPage = ({
  editingAccess
}: UserManagementPageProps): JSX.Element => {
  const { t } = useTranslation();
  const analytics = useAxeAccountAnalytics();

  useEffect(() => {
    analytics.viewUserAccessPage();
  }, []);

  return (
    <div className={globalStyles.wrap}>
      <PageTitle title={t('Deque Products User Management')} />
      <UserManagement editingAccess={editingAccess} />
    </div>
  );
};

export default UserManagementPage;
